import { jsx as r } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useResponsiveViewport as v, mediaQueries as T } from "../../../hooks/useResponsiveViewport.js";
import b from "../Popover/Popover.js";
import { PopoverContainerVariant as V } from "../Popover/types.js";
import { useTooltipListeners as x } from "./useTooltipListeners.js";
import { TypographyVariant as I } from "../Typography/types.js";
import N from "../Typography/Typography.js";
import P from "../../../hooks/element/useUniqueIdentifier.js";
import u from "classnames";
import { Fragment as p, cloneElement as O } from "../../../external/preact/dist/preact.module.js";
/* empty css             */
const w = (t) => typeof t == "string", M = ({ content: t, children: o, triggerRef: g, showTooltip: a, position: y, isContainerHovered: s = !1 }) => {
  var i, f, n;
  const e = P(), _ = v(T.down.sm), { isVisible: m, listeners: l } = x();
  return _ ? /* @__PURE__ */ r(p, { children: o }) : /* @__PURE__ */ r(p, { children: [
    o ? O(o, {
      ...o == null ? void 0 : o.props,
      role: "button",
      tabIndex: -1,
      ref: e,
      className: (i = o == null ? void 0 : o.props) != null && i.className ? u(`${(f = o == null ? void 0 : o.props) == null ? void 0 : f.className} adyen-pe__tooltip-target`, {
        " adyen-pe__tooltip-target--hovered": s
      }) : u("adyen-pe__tooltip-target", { "adyen-pe__tooltip-target--hovered": s }),
      ...l,
      "aria-describedby": `tooltip-${(n = e.current) == null ? void 0 : n.id}`
    }) : null,
    (m || a) && /* @__PURE__ */ r(
      b,
      {
        variant: V.TOOLTIP,
        targetElement: g ?? e,
        position: y,
        open: m || a,
        children: /* @__PURE__ */ r(p, { children: t && w(t) ? /* @__PURE__ */ r(N, { variant: I.CAPTION, children: t }) : { content: t } })
      }
    )
  ] });
};
export {
  M as Tooltip
};
